import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { CheckboxModule } from '../../components/checkbox/checkbox.component';
import { SafeUrlPipeModule } from '../../pipes/safe-url.pipe';
import { SharedModule } from '../../shared/shared.module';
import { LiveClassUnavailableModule } from '../live-class-unavailable/live-class-unavailable.module';
import { CohortCarouselComponent } from './cohort-carousel/cohort-carousel.component';
import { CohortResetModalComponent } from './cohort-reset-modal/cohort-reset-modal.component';
import { CohortResetService } from './cohort-reset.service';
import { CohortTileJoinComponent } from './cohort-tile/cohort-tile-join/cohort-tile-join.component';
import { CohortTileComponent } from './cohort-tile/cohort-tile.component';
import { provideCohortConfig } from './cohort.config.token';
import { CohortService } from './cohort.service';
import { CohortSelectionModalComponent } from './cohort-selection-modal/cohort-selection-modal.component';
import { UserwaySyncModule } from '../../shared/userway-sync.directive';

@NgModule({
  declarations: [CohortCarouselComponent, CohortTileComponent, CohortTileJoinComponent, CohortSelectionModalComponent, CohortResetModalComponent],
  imports: [
    CommonModule,
    HttpClientModule,
    TranslateModule,
    SharedModule,
    SafeUrlPipeModule,
    LiveClassUnavailableModule,
    UserwaySyncModule,
    CheckboxModule,
  ],
  providers: [CohortService, CohortResetService, provideCohortConfig()],
  exports: [CohortCarouselComponent, CohortSelectionModalComponent],
  entryComponents: [CohortSelectionModalComponent, CohortResetModalComponent],
})
export class CohortModule {}



// WEBPACK FOOTER //
// ./ts/app/home/cohort/cohort.module.ts